import parseJSON from './parse-json';

export function getURLParams($location) {
  const urlParams = new URLSearchParams($location.search);
  return Array.from(urlParams.keys()).reduce((prev, curr) => ({
    ...prev,
    [curr]: urlParams.get(curr),
  }), {});
}

export function getDOMParams($document) {
  // NOTE: this element is on legacy which could contain data that we want to
  // pass to the DRE 2.0 app
  const el = $document.querySelector('.returns-view-wrapper');
  const text = el?.getAttribute('data-order-details');
  const json = text?.replace(/&quot;/g, '"');
  const data = parseJSON(json, {});
  const { orderNumber, orderEmail, email } = data;
  const domParams = { };
  if (orderNumber) {
    domParams.orderNumber = orderNumber;
  }
  if (orderEmail && orderEmail !== 'false') {
    domParams.orderEmail = orderEmail;
  } else if (email && email !== 'false') {
    domParams.orderEmail = email;
  }
  return domParams;
}

export function getParams($window) {
  if (typeof $window !== 'object' || $window === null) {
    return {};
  }
  return {
    ...[$window.dre20params, {}].find(Boolean),
    ...getURLParams($window.location),
    ...getDOMParams($window.document),
  };
}